import CryptoJS from 'crypto-js';

const SECRET_KEY = 'zh-icbc';

/**
 * 解密token
 * @param {string} encryptedToken - URL中的加密token
 * @returns {object|null} 解密后的载荷数据
 */
export function decryptToken(encryptedToken) {
  try {
    let token = encryptedToken.replace(/-/g, '+').replace(/_/g, '/');

    // 补充Base64填充
    const pad = token.length % 4;
    if (pad) {
      token += '='.repeat(4 - pad);
    }

    // 2. 解密
    const bytes = CryptoJS.AES.decrypt(token, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (!decrypted) {
      throw new Error('解密结果为空');
    }

    // 3. 解析JSON
    const payload = JSON.parse(decrypted);

    // 4. 验证必需字段
    if (!payload.organizationId) {
      throw new Error('缺少organizationId');
    }

    return payload;
  } catch (error) {
    console.error('Token解密失败:', error.message);
    return null;
  }
}
